import { render } from "./cms-rich-text-editor.vue?vue&type=template&id=51a4b262&scoped=true"
import script from "./cms-rich-text-editor.vue?vue&type=script&lang=js"
export * from "./cms-rich-text-editor.vue?vue&type=script&lang=js"

import "./cms-rich-text-editor.vue?vue&type=style&index=0&id=51a4b262&scoped=true&lang=css"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a4b262"]])

export default __exports__